import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../services/authContext';
import config from '../config';

const NAV = {
  admin: [
    { path: '/students',    icon: '🎓', label: 'Students' },
    { path: '/lecturers',   icon: '👨‍🏫', label: 'Lecturers' },
    { path: '/programmes',  icon: '🏫', label: 'Programmes' },
    { path: '/modules',     icon: '📚', label: 'Modules' },
    { path: '/timetable',   icon: '🗓️', label: 'Timetable' },
    { path: '/materials',   icon: '📂', label: 'Materials' },
    { path: '/assignments', icon: '📋', label: 'Assignments' },
    { path: '/attendance',  icon: '✅', label: 'Attendance' },
    { path: '/exams',       icon: '📝', label: 'Assessments' },
    { path: '/grades',      icon: '🏆', label: 'Grades' },
    { path: '/reports',     icon: '📈', label: 'Reports' },
    { path: '/users',       icon: '👥', label: 'User Management' },
    { path: '/settings',    icon: '⚙️', label: 'Settings' },
  ],
  teacher: [
    { path: '/students',    icon: '🎓', label: 'Students' },
    { path: '/modules',     icon: '📚', label: 'Modules' },
    { path: '/timetable',   icon: '🗓️', label: 'Timetable' },
    { path: '/materials',   icon: '📂', label: 'Materials' },
    { path: '/assignments', icon: '📋', label: 'Assignments' },
    { path: '/attendance',  icon: '✅', label: 'Attendance' },
    { path: '/exams',       icon: '📝', label: 'Assessments' },
    { path: '/grades',      icon: '🏆', label: 'Grades' },
    { path: '/settings',    icon: '⚙️', label: 'Settings' },
  ],
  student: [
    { path: '/my-programme',   icon: '🏫', label: 'My Programme' },
    { path: '/my-modules',     icon: '📚', label: 'My Modules' },
    { path: '/my-materials',   icon: '📂', label: 'My Materials' },
    { path: '/my-assignments', icon: '📋', label: 'My Assignments' },
    { path: '/my-attendance',  icon: '✅', label: 'My Attendance' },
    { path: '/my-exams',       icon: '📝', label: 'My Assessments' },
    { path: '/my-grades',      icon: '🏆', label: 'My Grades' },
    { path: '/settings',       icon: '⚙️', label: 'Settings' },
  ],
  parent: [
    { path: '/my-children',          icon: '👨‍👩‍👧', label: 'My Children' },
    { path: '/children-attendance',  icon: '✅', label: 'Attendance' },
    { path: '/children-grades',      icon: '🏆', label: 'Grades' },
    { path: '/children-assignments', icon: '📝', label: 'Assignments' },
    { path: '/settings',             icon: '⚙️', label: 'Settings' },
  ],
  common: [
    { path: '/dashboard',     icon: '📊', label: 'Dashboard' },
    { path: '/notifications', icon: '🔔', label: 'Notifications' },
    { path: '/announcements', icon: '📣', label: 'Announcements' },
    { path: '/calendar',      icon: '📅', label: 'Calendar' },
    { path: '/messages',      icon: '✉️',  label: 'Messages' },
  ],
};

const Sidebar = ({ isOpen, closeSidebar }) => {
  const location = useLocation();
  const { user } = useAuth();
  const roleItems   = user ? (NAV[user.role] || []) : [];
  const commonBottom = NAV.common.filter(i => i.path !== '/dashboard');
  const items = [NAV.common.find(i => i.path === '/dashboard'), ...roleItems, ...commonBottom];

  return (
    <>
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <span className="sidebar-brand">{config.app.shortName}</span>
          <button className="sidebar-close" onClick={closeSidebar} aria-label="Close menu">×</button>
        </div>

        <nav className="sidebar-menu">
          <ul className="nav-menu">
            {items.map((item, i) => (
              <li key={i}>
                <Link
                  to={item.path}
                  className={`sidebar-item ${location.pathname === item.path ? 'active' : ''}`}
                  onClick={closeSidebar}
                >
                  <span className="sidebar-icon">{item.icon}</span>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="sidebar-footer">
          <p className="sidebar-copyright">
            &copy; {new Date().getFullYear()} Mokorotlo College Of Creative Technology. All rights reserved.
          </p>
        </div>
      </aside>

      {isOpen && <div className="sidebar-overlay" onClick={closeSidebar} />}
    </>
  );
};

export default Sidebar;
